export default __webpack_public_path__ + "static/logo-mobile-1038a5c93eb69795ab3256f36e667827.svg";